import React from 'react';

const StatCard = ({ title, value, icon, color = 'primary' }) => {
  return (
    <div className="card stat-card shadow-sm border-0 rounded-3 h-100">
      <div className="card-body d-flex align-items-center">
        <div className={`bg-${color} bg-opacity-10 rounded-3 p-3 me-3`}>
          <i className={`bi ${icon} text-${color} fs-4`}></i>
        </div>
        <div>
          <h6 className="card-title text-muted mb-1 fw-medium">{title}</h6>
          <h3 className="card-text mb-0 fw-bold text-dark">{value}</h3>
        </div>
      </div>
    </div>
  );
};

export default StatCard;